if (!customElements.get('grid-buttons')) {
  class GridButtons extends HTMLElement {
    constructor() {
      super();
      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      const anchor = event.target.closest('a');

      if (!anchor) return;
      if (anchor.classList.contains('is-active')) return;

      event.preventDefault();

      this.anchors.forEach(element => element.classList.remove('is-active'));
      anchor.classList.add('is-active');

      document.dispatchEvent(new CustomEvent('alexa:collection-grid-layout-change',
        { detail: { view: anchor.getAttribute('data-view') } }
      ));
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.anchors = this.querySelectorAll('a');
      this.addEventListener('click', this.handleClickRef);
    }
  }
  customElements.define('grid-buttons', GridButtons);
}
